import { axios, getAxiosConfig, ServerAxiosRequestData } from '@config/axios';
import Environment from '@config/index';
import { FAV_CONSTANTS } from '@constants/favorites';
import { FAV_DEFAULT_SORT_ORDER } from '@constants/profile-fav-sort';
import { ApiResponse } from '@interfaces/api';
import { HotFiltersPaginationStatsResponse, HotFiltersResponse } from '@interfaces/api/responses/hot-filters.response';
import { User } from '@interfaces/models/user';

type GetHotFiltersProductsPayload = {
  userId: User['id'];
  sortBy: string;
  hotFiltersQuery: {};
  paginationQuery: Partial<HotFiltersPaginationStatsResponse>;
};

const BASE_URL = `${Environment.apiBaseUrl}/users`;

export const getUsersFavoritesProductsWithFilters = async (
  payload: GetHotFiltersProductsPayload,
  serverAxiosRequestData?: ServerAxiosRequestData,
): Promise<ApiResponse<HotFiltersResponse>> => {
  const { userId, sortBy, hotFiltersQuery, paginationQuery } = payload;

  const axiosConfig = getAxiosConfig(serverAxiosRequestData);

  axiosConfig.params = {
    ...axiosConfig.params,
  };

  const requestPayload = {
    filters: hotFiltersQuery,
    sortBy: sortBy ?? FAV_DEFAULT_SORT_ORDER,
    pagination: {
      offset: paginationQuery?.offset ?? FAV_CONSTANTS.FAV_DEFAULT_OFFSET,
      limit: paginationQuery?.limit ?? FAV_CONSTANTS.FAV_DEFAULT_LIMIT,
    },
  };

  const { data } = await axios.post<ApiResponse<HotFiltersResponse>>(
    `${BASE_URL}/${userId}/favorites`,
    requestPayload,
    axiosConfig,
  );
  return data;
};
